import '../../styles/restScreens.css';
import { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';
import { matchValues, reachedViaEntries } from '../../lib/reachedVia';

// BL-177 PR C7: "Reached via: (404) 594-2667 · text · Reservation@therideatl.com · email · WhatsApp". Each entry opens that conversation
// (the conversation list's own rules decide what the viewer may open).
export default function ReachedVia({ contact, compact = false }) {
    const [entries, setEntries] = useState(null);
    const { phones, emails } = matchValues(contact);
    const matchKey = `${contact?.id || ''}|${phones.join(',')}|${emails.join(',')}`;

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try { await loadEntries(); } catch (err) { if (!cancelled) setEntries([]); }
        }
        async function loadEntries() {
            if (!phones.length && !emails.length) { setEntries([]); return; }
            const filters = [];
            if (phones.length) filters.push(`contact_phone.in.(${phones.map(p => `"${p}"`).join(',')})`);
            if (emails.length) {
                const variants = [...new Set(emails.flatMap(e => [e, e.toLowerCase()]))];
                filters.push(`contact_email.in.(${variants.map(e => `"${e}"`).join(',')})`);
            }
            const { data: sessions, error } = await supabaseClient
                .from('intake_sessions')
                .select('id, channel, contact_phone, contact_email, external_thread_id, email_provider_id, last_inbound_at, created_at')
                .or(filters.join(','))
                .order('last_inbound_at', { ascending: false, nullsFirst: false })
                .limit(200);
            if (cancelled) return;
            if (error) { setEntries([]); return; }
            const providerIds = [...new Set((sessions || []).map(s => s.email_provider_id).filter(Boolean))];
            let providers = {};
            if (providerIds.length) {
                const { data } = await supabaseClient.from('org_email_providers').select('id, from_email').in('id', providerIds);
                providers = Object.fromEntries((data || []).map(p => [p.id, p.from_email]));
            }
            if (!cancelled) setEntries(reachedViaEntries(sessions || [], contact, providers));
        }
        load();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchKey]);

    if (entries === null) return null;
    return (
        <div data-m6-layout="clients" data-m6-component="ReachedVia" className={compact ? 'text-xs' : 'text-sm'} data-testid="reached-via">
            <span className="text-[11px] uppercase tracking-wide text-[var(--ink-muted)]">Reached via</span>{' '}
            {entries.length === 0 ? (
                <span className="text-[var(--ink-muted)]">no conversations yet</span>
            ) : entries.map((entry, index) => (
                <span key={entry.key}>
                    {index > 0 && <span className="text-[var(--ink-muted)]"> · </span>}
                    <a
                        href={`/communications?session=${entry.sessionId}`}
                        onClick={event => event.stopPropagation()}
                        className="text-[var(--ink)] underline decoration-dotted underline-offset-2 hover:decoration-solid"
                    >{entry.text}</a>
                </span>
            ))}
        </div>
    );
}
